import _ from 'underscore';
import AdsCreateView from '@bingads-webui-campaign-legacy/crud-ad/view/adGroupAdsEditor';
import * as schemaMapper from '@bingads-webui-campaign-legacy/crud-ad/schemaMapper';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const availableAdTypes = [
  'Text',
  'AppInstall',
  'DynamicSearch',
  'ExpandedText',
  'ResponsiveSearch',
  'Responsive',
];

export default class View extends AdsCreateView {
  initialize(options = {}) {
    super.initialize({
      showAdGroupInfo: false,
      isSaveToServer: false,
      usePanel: options.usePanel,
      isForVNext: options.isForVNext,
      Campaign: options.Campaign,
      activityLogger: options.activityLogger,
      adGroupType: options.adGroupType,
      newI18n: options.newI18n,
      perfMarker: options.perfMarker,
      serverContext: options.serverContext,
    });

    this.allAppealableErrors = false;
  }

  logActivity(message) {
    if (this.activityLogger) {
      this.activityLogger.signal(message, 'ads panel');
    }
  }

  validate() {
    this.clearAlertMessages();

    let hasAds = !this.isEmpty();
    let hasUniqAds = !this.viewModel.hasDuplicateAds();

    if (!hasAds) {
      this.logActivity('invalid: has no ads');
    }

    if (!hasUniqAds) {
      this.logActivity('invalid: has duplicate ads');
    }

    return hasAds && hasUniqAds;
  }

  handleAdsError(response) {
    let allAds = this.viewModel.getAds();

    this._clearAdsErrors(allAds);

    _.each(availableAdTypes, (type) => {
      let ads = _.where(allAds, { Type: type });

      _.each(response[`${type}Ads`], (entity, index) => {
        if (_.isFinite(entity.Id) && !ads[index].isSaved) {
          ads[index].Id = entity.Id;
          ads[index].isSaved = true;
        } else if (!_.isEmpty(entity.errors)) {
          ads[index].hasError = true;
          ads[index].errors = entity.errors;
        }
      }, this);
    });

    this.viewModel.slb.refreshSource();

    if (this._hasApiErrors(allAds)) {
      this.viewModel.alertMessage(i18n.get('CreateAdGroup_AdsApiError_FixErrorNote'));
      this.allAppealableErrors = false;
    } else {
      this.viewModel.alertMessage('');
      this.allAppealableErrors = true;
    }
  }

  getDeletedItems(adgroupId) {
    return _.map(this.viewModel.deletedAdIds, (ad) => {
      return _.defaults(ad, {
        resourceName: 'Ad',
        parentId: adgroupId,
      });
    });
  }

  updateLanguage(language) {
    this.language = language;
  }

  emptyDeletedItems() {
    this.viewModel.deletedAdIds = [];
  }

  getValues(adGroupName, campaignName, adgroupId) {
    let ads = this.viewModel.getAds();
    let models = {};

    _.each(availableAdTypes, (type) => {
      models[`${type}Ads`] = _.map(_.where(ads, { Type: type }), (ad) => {
        const formatedAd = this._formatAd(ad, { AdGroupName: adGroupName, CampaignName: campaignName });

        if (adgroupId) {
          formatedAd.AdGroup = { Id: adgroupId };
        }

        return formatedAd;
      });
    });

    return models;
  }

  getCachedImageExtensionChanges() {
    return this.viewModel.getCachedImageExtensionChanges();
  }

  _formatAd(ad, base) {
    let fields = ad.isSaved ? _.union(schemaMapper[ad.Type](), ['Id']) : schemaMapper[ad.Type]();

    return _.extend(_.pick(ad, fields), base);
  }

  _hasApiErrors(allAds) {
    return _.some(allAds, (ad) => {
      return ad.hasError;
    });
  }

  _clearAdsErrors(ads) {
    _.each(ads, (ad) => {
      ad.hasError = false;
      ad.errors = [];
    });
  }
}
